import {
  TERMINAL_LOGS_FIELD_FILTER_REQUEST,
  TERMINAL_LOGS_FIELD_FILTER_REQUEST_FAILURE,
  TERMINAL_LOGS_FIELD_FILTER_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export const terminalLogsFilterFieldReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_LOGS_FIELD_FILTER_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_LOGS_FIELD_FILTER_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case TERMINAL_LOGS_FIELD_FILTER_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    // case FILTER_FIELD_CLEAN_REQUEST:
    //   return Object.assign({}, state, {
    //     loading: false,
    //     errors: {},
    //     payload: [],
    //     pagination: {},
    //   });

    default:
      return state;
  }
};

export default terminalLogsFilterFieldReducer;
